import { ExpenseRequest } from "../../../types/types";
import { api } from "../api";

const expenseSaveByVehicle = async (
    token: string,
    model: ExpenseRequest,
) => {
    return api.post("/expenses", model, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export default expenseSaveByVehicle;
